<template>
  <v-dialog
    v-model="dialog"
    :overlay="false"
    max-width="900px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <div>
        <v-text-field
          outlined
          :error-messages="isError ? 'Negative Discount is not allowed' : ''"
          name="DiscountCashName"
          label="Discount"
          id="DiscountCash_id"
          :value="discount"
          v-bind="attrs"
          v-on="on"
          readonly
        ></v-text-field>
      </div>
    </template>
    <v-card>
      <v-card-title class="teal darken-4 white--text">
        Discount Form
      </v-card-title>
      <v-card class="px-3 py-2 mb-1 grey lighten-4">
        <!-- <h4>{{ Inv.categ }}</h4> -->
        <template v-for="(item, index) in itemList">
          <div :key="item._id + 'div'">
            <newInventory
              :key="item._id + index"
              :ItemRow="item"
              @OnError="OnError"
            ></newInventory>
            <v-divider class="white mb-4"></v-divider>
          </div>
        </template>
      </v-card>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    itemList: { type: Array, required: true },
    hasError: { type: Function, required: true },
  },
  components: {
    newInventory: () =>
      import("@/components/HQ/TheWay/itemRow/_discountRow.vue"),
  },
  data() {
    return {
      dialog: false,
      errors: [],
    };
  },
  computed: {
    discount() {
      let total = 0;
      // for (const key in this.itemList) {
      // if (true) {
      total += this.itemList.reduce((total, item) => {
        return total + item.Discount;
      }, 0);
      // }
      // }
      return total.toLocaleString();
    },

    isError: {
      get: function() {
        // console.log(this.errors);
        return this.errors.some(item => item.isError == true);
      },
      set: function(v) {
        this.errors = this.errors.filter(item => v._id !== item._id);
        this.errors.push(v);
      },
    },
  },
  methods: {
    OnError(v) {
      // console.log(v);
      this.isError = v;
      this.hasError(this.isError);
      // this.errors[v._id] = v.isError;
    },
  },
};
</script>
